import { BaseService } from './base.service'
import $store from '@/store'

export class NotificationsService extends BaseService {
  static get entity () {
    return 'notifications'
  }

  static get listUrl () {
    return 'Notification/GetNotification'
  }

  static get detailUrl () {
    return 'Notification/NotificationDetail'
  }

  static setAllRead () {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post('Notification/IsReadOrUnReadAll', { isRead: true })
        .then(response => {
          if (response.data.data.IsResult === true) {
            $store.commit('notifications/SET_ALL_READ')
          }
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static setRead (notificationId) {
    const params = {
      ...{ NotificationId: notificationId, IsRead: true }
    }
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('Notification/IsReadOrUnRead', { params })
        .then(response => {
          console.log(response)
          if (response.data.data.IsRead === true) {
            $store.commit('notifications/SET_READ', notificationId)
            $store.commit('unreadNotifications/REMOVE_ITEM', notificationId)
          }
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static deleteOne (notificationId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get(`Notification/DeleteNotification?notificationId=${notificationId}`)
        .then(response => {
          if (response.data.data.IsResult === true) {
            $store.commit('notifications/REMOVE_ITEM', notificationId)
            $store.commit('unreadNotifications/REMOVE_ITEM', notificationId)
          }
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static deleteAll () {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('Notification/DeleteAllNotification')
        .then(response => {
          if (response.data.data.IsResult === true) {
            $store.commit('notifications/EMPTY_ITEMS')
            $store.commit('unreadNotifications/EMPTY_ITEMS')
          }
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }
}
